export default __webpack_public_path__ + "images/OY.e936b7d.png";